export const LOGIN = "LOGIN"
export const LOGIN_FAIL = "LOGIN_FAIL"
export const LOGOUT = "LOGOUT"
export const USER_CHANGE = "USER_CHANGE"